import { render, staticRenderFns } from "./EnablePushNotificationsCard.vue?vue&type=template&id=ffaa5ed4&scoped=true"
import script from "./EnablePushNotificationsCard.vue?vue&type=script&lang=js"
export * from "./EnablePushNotificationsCard.vue?vue&type=script&lang=js"
import style0 from "./EnablePushNotificationsCard.vue?vue&type=style&index=0&id=ffaa5ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaa5ed4",
  null
  
)

export default component.exports